import { Inject, Injectable } from '@angular/core';
import { PaginatedRepository } from '../pagination/paginated.repository';
import { RegHubCommonConfig, REG_HUB_COMMON_CONFIG } from '../../reg-hub-common-config';
import { Invitation, InvitationSanitized } from '../../interfaces/invitations/invitation';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvitationsService extends PaginatedRepository<Invitation> {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    http: HttpClient,
    messageService: ToastrService) {
    super(
      http,
      messageService);

    this._baseLink = `${config.rootUrl}/invitations`;
  }

  public getInvitations(defaultParams?: HttpParams): Observable<Invitation[]> {
    let params = defaultParams ? defaultParams : new HttpParams();
    return this.http.get<Invitation[]>(this._baseLink, { params: params });
  }

  public getInvitationsSanitized(defaultParams?: HttpParams): Observable<InvitationSanitized[]> {
    let params = defaultParams ? defaultParams : new HttpParams();
    return this.http.get<InvitationSanitized[]>(this._baseLink + "/sanitized", { params: params });
  }
}
